import React, {useState, useEffect} from "react"

function MenuTab(props) {
    const [tabColor] = useState("tabColour " + props.tabData.color)
    const [tabSize] = useState(props.tabData.shortTab ? "shortTab" : "longTab")
    const [tabGroup, setTabGroup] = useState("")
    const [tabName] = useState(props.tabData.tabText)
    
    useEffect(() => {
        setTabGroup(props.selected ? tabSize + " selectedMenuTab" : tabSize)
    }, [tabSize, props.selected])
    
    function handleClick() {
        const pageTarget = props.tabData.id
        props.callBack(pageTarget)
    }
    
    return (
        <div className={"menuTab " + tabGroup}>
            <div className={"menuTabShape " + tabSize} onClick={handleClick}>
                <div className="mainTabSection">{tabName}</div>
                <div className={tabColor}></div>
                <div className="tabCornerCut"></div>
            </div>
        </div>
    )
}

export default MenuTab